document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('[data-scroll]').forEach(a=>a.addEventListener('click',e=>{const t=document.querySelector(a.getAttribute('href'));if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth'})}}))});

document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-vehicle-slider]').forEach(slider=>{
    const track=slider.querySelector('.vehicle-slider-track');
    const slides=[...slider.querySelectorAll('.vehicle-slide')];
    const prev=slider.querySelector('.slider-prev');
    const next=slider.querySelector('.slider-next');
    const current=slider.querySelector('[data-slide-current]');
    const dotsWrap=slider.querySelector('.slider-dots');
    let index=0, startX=0;
    const dots=slides.map((_,i)=>{const b=document.createElement('button');b.type='button';b.className='slider-dot';b.setAttribute('aria-label',`Show vehicle photo ${i+1}`);b.addEventListener('click',()=>go(i));dotsWrap.appendChild(b);return b});
    function go(i){index=(i+slides.length)%slides.length;track.style.transform=`translateX(-${index*100}%)`;current.textContent=String(index+1).padStart(2,'0');dots.forEach((d,j)=>d.classList.toggle('active',j===index));}
    prev.addEventListener('click',()=>go(index-1));next.addEventListener('click',()=>go(index+1));
    slider.addEventListener('touchstart',e=>{startX=e.touches[0].clientX},{passive:true});
    slider.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-startX;if(Math.abs(dx)>45)go(index+(dx<0?1:-1))},{passive:true});
    go(0);
  });
});

document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-banner-slider]').forEach(slider=>{
    const track=slider.querySelector('.banner-track');
    const slides=[...slider.querySelectorAll('.banner-slide')];
    const dotsWrap=slider.querySelector('.banner-dots');
    const current=slider.querySelector('[data-banner-current]');
    let index=0,startX=0,timer;
    const dots=slides.map((_,i)=>{const b=document.createElement('button');b.type='button';b.className='banner-dot';b.setAttribute('aria-label',`Show banner photo ${i+1}`);b.addEventListener('click',()=>go(i,true));dotsWrap.appendChild(b);return b});
    function go(i,restart=false){index=(i+slides.length)%slides.length;track.style.transform=`translateX(-${index*100}%)`;current.textContent=String(index+1).padStart(2,'0');dots.forEach((d,j)=>d.classList.toggle('active',j===index));if(restart)auto();}
    function auto(){clearInterval(timer);timer=setInterval(()=>go(index+1),5500)}
    slider.querySelector('.banner-prev').addEventListener('click',()=>go(index-1,true));
    slider.querySelector('.banner-next').addEventListener('click',()=>go(index+1,true));
    slider.addEventListener('touchstart',e=>{startX=e.touches[0].clientX},{passive:true});
    slider.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-startX;if(Math.abs(dx)>45)go(index+(dx<0?1:-1),true)},{passive:true});
    go(0);auto();
  });
});


document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-winner-slider]').forEach(slider=>{
    const track=slider.querySelector('.winner-slider-track');
    const slides=[...slider.querySelectorAll('.winner-slide')];
    const dotsWrap=slider.querySelector('.winner-dots');
    const current=slider.querySelector('[data-winner-current]');
    let index=0,startX=0;
    const dots=slides.map((_,i)=>{const b=document.createElement('button');b.type='button';b.className='winner-dot';b.setAttribute('aria-label',`Show winner slide ${i+1}`);b.addEventListener('click',()=>go(i));dotsWrap.appendChild(b);return b});
    function go(i){index=(i+slides.length)%slides.length;track.style.transform=`translateX(-${index*100}%)`;current.textContent=String(index+1).padStart(2,'0');dots.forEach((d,k)=>d.classList.toggle('active',k===index));}
    slider.querySelector('.winner-prev').addEventListener('click',()=>go(index-1));
    slider.querySelector('.winner-next').addEventListener('click',()=>go(index+1));
    slider.addEventListener('touchstart',e=>{startX=e.touches[0].clientX},{passive:true});
    slider.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-startX;if(Math.abs(dx)>45)go(index+(dx<0?1:-1))},{passive:true});
    go(0);
  });
});
